module.exports = __webpack_public_path__ + "static/media/ann-lose.5426465a.png";